// extracted by mini-css-extract-plugin
module.exports = {"menu-container":"_21WGR9dLWJWdcJtlwkU8HR","menu-item-title":"_3HheRH2UFTVXtecxQIovRG","icon-back":"_2wxb9q3_ugSesVvmu9ciwu"};